import React, { Component } from 'react';

//import '../QualityReasonGroup/node_modules/bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash, faEye, faPlus, faFileImport, faDownload } from '@fortawesome/free-solid-svg-icons';
import dateTime from '../../utill/dateTime';
import swal from 'sweetalert';
import api from '../../config.json';
import axios from '../../httpServices/httpService';
import Table from '../../Common/table';

import _, { cloneDeep, split, unionWith, uniqBy, uniqWith } from 'lodash'
import Loading from '../../utill/LoadingComponent';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import XLSX from 'xlsx';
import valid from '../../utill/validation';
import joi from 'joi';
import { Modal } from 'react-bootstrap';

function mergeArrayAggregate(bufferArry, compareKey, mergeKey) {
  bufferArry = [...bufferArry]
  for (let i = 0; i < bufferArry.length; i++) {
    for (let j = i + 1; j < bufferArry.length; j++) {
      if (bufferArry[i][compareKey] === bufferArry[j][compareKey]) {
        bufferArry[i][mergeKey] = [...bufferArry[j][mergeKey], ...bufferArry[i][mergeKey]]
        bufferArry.splice(j, 1);
        j--;
      }
    }
  }
  return bufferArry
}


function convertToDateObject(date) {
  const dateTimeString = date.split("T");
  let dateString = dateTimeString[0];
  let timeString = dateTimeString[1];
  timeString = timeString.split(":")
  let parts = dateString.split('/'); // Split the string into parts
  let formattedDate = new Date(parts[2], parts[1] - 1, parts[0], parseInt(timeString[0]), parseInt(timeString[1]), 0, 0);
  return formattedDate
}

class PartMasterTable extends Component {

  state = {
    componentList: [],
    sortColumn: { path: 'PartID', order: 'asc' },
    querySuccess: false,
    inspectionTypeList:[],

    excelData: [],
    arrayProcessIndex: 0,
    errorModal: false,
    errorMessage: '',
    errorFlag: false,
    rowNumber: 0,
    errors: {},
    objKey: '',
  }

  componentDidMount() {
    this.props.Heading('Part Master')

    this.setState({ querySuccess: true });
    this.getInpectionTypeList()
    axios.get(api.api1 + 'partMaster')
      .then((result) => {
        // consol(result.data)
        if (result.data.length > 0) {
          this.setState({ componentList: result.data, querySuccess: false });
        }
        else {
          this.setState({ querySuccess: false })
        }
      })
      .catch((err) => {
        this.setState({ querySuccess: false });
        toast.success(`${err}`, {
          position: 'bottom-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            background: 'red', // Set your desired background color
            color: 'white',     // Set your desired text color
          },
        });

      })


  }

  getInpectionTypeList=()=>{
    this.setState({ querySuccess: true });
    axios.get(api.api + 'inspectionType')
      .then((result) => {
        // consol(result.data)
        if (result.data.length > 0) {
          this.setState({ inspectionTypeList: result.data, querySuccess: false });
        }
        else {
          this.setState({ querySuccess: false })
        }
      })
      .catch((err) => {
        this.setState({ querySuccess: false });
        toast.success(`${err}`, {
          position: 'bottom-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            background: 'red', // Set your desired background color
            color: 'white',     // Set your desired text color
          },
        });

      })
  }

  onDelete = (data) => {

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.setState({ querySuccess: true });
        axios
          .delete(api.api + "partMaster/" + data._id, { data: data })
          .then(result => {
            // consol(result.data)
            if (result.data.ok === 1 && result.data.deletedCount === 1) {
              let filterData = this.state.componentList.filter(
                obj => obj._id !== data._id
              );
              this.setState({ componentList: filterData, querySuccess: false });
            }
          })
          .catch(err => {
            this.setState({ querySuccess: false });
            toast.success(`${err}`, {
              position: 'bottom-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: 'red', // Set your desired background color
                color: 'white',     // Set your desired text color
              },
            });
          });
      } else {
        this.setState({ querySuccess: false });
        // swal("Your imaginary file is safe!");
      }
    });




  }


  columns = [
    { path: 'PartID', label: 'Part ID' },
    { path: 'PartName', label: 'Part Name', content: (obj) => <label>{obj.PartName ? obj.PartName : '-'}</label> },
    { key: 'InspectionType', label: 'Inspection Type', content: (obj) => obj.Standards.map(one => <React.Fragment><label>{one.InspectionType}</label><br /></React.Fragment>) },

    { key: 'StandardVersion', label: 'Standard Version', content: (obj) => obj.Standards.map(one => <React.Fragment><label>{one.StandardVersion}</label><br /></React.Fragment>) },
    { key: 'EffectiveFrom', label: 'Effective From', content: (obj) => obj.Standards.map(one => <React.Fragment><label>{dateTime.getStringOfDateTime(one.EffectiveFrom)}</label><br /></React.Fragment>) },
    //{key:'NetWeightPerComponent',label:'Net Component Weight',content:(obj)=>obj.Operation.map(one=><React.Fragment><label>{one.NetWeightPerComponent}</label><br/></React.Fragment>)},
    { key: 'Parameter', label: 'Parameter', content: (obj) => obj.Standards.map(a => a.Standard.map(one => <React.Fragment><label>{one.Parameter ? one.Parameter.toString() : "-"}</label><br /></React.Fragment>)) },
    { key: 'StandardType', label: 'Standard Type', content: (obj) => obj.Standards.map(a => a.Standard.map(one => <React.Fragment><label>{one.StandardType ? one.StandardType.toString() : "-"}</label><br /></React.Fragment>)) },
    //{key:'ScrapWeightCycle',label:'Scrap Weight / Cycle',content:(obj)=>obj.Operation.map(one=><React.Fragment><label>{one.ScrapWeightCycle?one.ScrapWeightCycle.toString():'-'}</label><br/></React.Fragment>)},
    { key: 'Dimension', label: 'Dimension', content: (obj) => obj.Standards.map(a => a.Standard.map(one => <React.Fragment><label>{one.Dimension ? one.Dimension.toString() : "-"}</label><br /></React.Fragment>)) },
    { key: 'PlusTolerance', label: 'Plus Tolerance', content: (obj) => obj.Standards.map(a => a.Standard.map(one => <React.Fragment><label>{one.PlusTolerance ? one.PlusTolerance.toString() : "-"}</label><br /></React.Fragment>)) },
    { key: 'MinusTolerance', label: 'Minus Tolerance', content: (obj) => obj.Standards.map(a => a.Standard.map(one => <React.Fragment><label>{one.MinusTolerance ? one.MinusTolerance.toString() : "-"}</label><br /></React.Fragment>)) },
    //{key:'CyclePerParts',label:'Cycles / Part',content:(obj)=>obj.Operation.map(one=><React.Fragment><label>{one.CyclePerParts?one.CyclePerParts:'-'}</label><br/></React.Fragment>)},
    { key: 'CTQ', label: 'CTQ', content: (obj) => obj.Standards.map(a => a.Standard.map(one => <React.Fragment><label>{one.CTQ ? "Yes" : "No"}</label><br /></React.Fragment>)) },

    { key: 'createdAt', label: 'Created Date', content: (obj) => <React.Fragment><label>{dateTime.getStringOfDateTime(obj.createdAt)}</label><br /></React.Fragment> },
    { key: 'updatedAt', label: 'Last Updated Date', content: (obj) => <React.Fragment><label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label><br /></React.Fragment> },
    { key: 'update', content: user => <button onClick={() => this.props.history.push("/setting/partMaster/add", { action: 'update', data: user })} className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faEdit} /></button> },
    // { key: 'view', content: user => <button onClick={() => this.props.onView(user)} className="btn btn-sm btn-info"><FontAwesomeIcon icon={faEye} /></button> },
    { key: 'delete', content: user => <button onClick={() => this.onDelete(user)} className="btn btn-sm btn-danger"><FontAwesomeIcon icon={faTrash} /></button> }

  ]

  handleSort = sortColumn => {
    // consol(sortColumn);
    if (this.state.componentList.length > 0) {
      const sorted = _.orderBy(this.state.componentList, [sortColumn.path], [sortColumn.order]);
      this.setState({ sortColumn, componentList: sorted });
    }
  }

  validateType=(arr)=>{
    const list=[...this.state.inspectionTypeList];
    let error=false;
    let index=0;
    for(let i=0;i<arr.length;i++){
     if(!list.some(one=>one.InspectionType.toLowerCase()!==arr[i].InspectionType.toLowerCase())){
       error=true;
       index=i;
       break;
     }
    }
    return {error:error,index:index}
   }
 

  handleUploadGuagesDoc = () => {
    let link = document.createElement('input');
    link.setAttribute('type', 'file');
    link.setAttribute('name', 'PartMastrList');
    // link.setAttribute('onChange', handleOnChangeFile);
    let self = this;
    document.body.appendChild(link);
    link.click();
    link.onchange = function (e) {
      e.preventDefault();

      let fr = new FileReader();
     
      // if (e.currentTarget.files[0].size < 51200 && e.currentTarget.files[0].size > 2000) {
      fr.readAsBinaryString(e.currentTarget.files[0]);
      fr.onloadend = async function (e) {
        const wb = XLSX.read(e.target.result, { type: 'binary', cellDates: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        let dataArray = []
        let keyArr = data[0]
        let arr = data.slice(1, data.length)

      

        arr.forEach((oneArr) => {
          if (oneArr.length > 0) {
            let obj = {}
            oneArr.forEach((value, i) => {
              if (keyArr[i] == 'Tool') {
                if (value && value !== '') {
                  obj.ToolRequiredToProduce = true;
                  value = value.split('#');
                  obj[[keyArr[i]]] = value;
                } else {
                  obj.ToolRequiredToProduce = false;
                }

              } else {
                obj[[keyArr[i]]] = value;
              }
            })
            // if (obj.Tool) {
            //   obj.ToolRequiredToProduce = true;
            // } else {
            //   obj.ToolRequiredToProduce = false;
            // }
            dataArray.push(obj);
          }

        })
        const error=self.validateType(dataArray);
        if(error.error){
          swal(`Validation failed inspection type not exist at row number ${error.index+1}`,{dangerMode:true})
          return 
        }
        let finalDataArr = []
        for (let i = 0; i < dataArray.length; i++) {
          if (finalDataArr.length == 0) {
            let obj1 = { ...dataArray[i] }
            delete obj1.PartID;
            delete obj1.PartName;
            let obj = { PartID: dataArray[i].PartID, PartName: dataArray[i].PartName, Standards: [] };
            obj.Standards.push(obj1)
            finalDataArr.push(obj);
          } else {
            let filterData = finalDataArr.filter(one => one.PartID == dataArray[i].PartID)
            if (filterData.length > 0) {
              let obj = { ...dataArray[i] }
              finalDataArr.filter(one => one.PartID == dataArray[i].PartID)[0].Standards.push(obj)
            } else {
              let obj1 = { ...dataArray[i] }

              let obj = { PartID: dataArray[i].PartID, PartName: dataArray[i].PartName, Standards: [] };
              obj.Standards.push(obj1)
              finalDataArr.push(obj);
            }
          }
        }
        // finalDataArr.forEach((x)=>{
        //   x.Standards.forEach((y)=>{

        //   })
        // })

        finalDataArr.forEach((one) => {
          one.PartID = one.PartID ? one.PartID.toString() : one.PartID;
          one.PartName = one.PartID ? one.PartID.toString() : one.PartID;
          one.Standards.forEach((op) => {
            delete op.PartID
            delete op.PartName
            op.Standard = one.Standards.filter(x => x.InspectionType == op.InspectionType)
          })
          one.Standards = uniqWith(one.Standards, (a, b) => a.InspectionType === b.InspectionType)
        })
        const arr1=[]
        finalDataArr=cloneDeep(finalDataArr)
        finalDataArr.forEach((one) => {
          const cloneObj=cloneDeep(one)
          cloneObj.Standards.forEach((obj,idx) => {
            obj=cloneDeep(obj)
           
            obj.Standard.forEach((x,i) => {
              x=cloneDeep(x)
              delete x.InspectionType
              delete x.Standard
              x.CTQ = false
              if (x.CTQ && x.CTQ.toLowerCase() == "yes")
                x.CTQ = true
                cloneObj.Standards[idx].Standard[i]=x
            })
            cloneObj.Standards[idx]=obj
          })
          arr1.push(cloneObj);
        })
        arr1.forEach(obj=>{
          obj.Standards.forEach((one)=>{
            
            one.Standard.forEach((x,i)=>{
              const clone=cloneDeep(x)
              delete clone.Standard
              one.Standard[i]=clone;
            })
          })
        })
        arr1.forEach(x=>{
          x.Standards.forEach((obj)=>{
            delete obj.CTQ
            delete obj.Dimension
            delete obj.Method
            delete obj.MinusTolerance
            delete obj.PlusTolerance
            delete obj.Parameter
            delete obj.StandardType
            delete obj.UOM
          })
        })


        self.setState({ excelData: arr1 });
        await self.sendDataToServer(arr1, arr1, self.state.arrayProcessIndex)
        // consol("Data>>>" + finalDataArr);
      };
      // }
      // else {
      //   swal('File Size Should Be Between 2KB to 50KB');
      // }
    }
    document.body.removeChild(link);

  }



  handleUploadGuagesDoc1 = () => {
    let link = document.createElement('input');
    link.setAttribute('type', 'file');
    link.setAttribute('name', 'PartMastrList');
    // link.setAttribute('onChange', handleOnChangeFile);
    let self = this;
    document.body.appendChild(link);
    link.click();
    link.onchange = function (e) {
      e.preventDefault();

      let fr = new FileReader();

      // if (e.currentTarget.files[0].size < 51200 && e.currentTarget.files[0].size > 2000) {
      fr.readAsBinaryString(e.currentTarget.files[0]);
      fr.onloadend = async function (e) {
        const wb = XLSX.read(e.target.result, { type: 'binary', cellDates: true });
        let sheets = {}
        wb.SheetNames.forEach((name) => {
          sheets[name] = []
          const ws = wb.Sheets[name];
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
          let keyArr = data[0]
          let arr = data.slice(1, data.length)
          arr.forEach((oneArr) => {
            if (oneArr.length > 0) {
              let obj = {}
              oneArr.forEach((value, i) => {
                if (keyArr[i] == "EffectiveFrom") {
                  obj[[keyArr[i]]] = convertToDateObject(value);
                }
                else if (keyArr[i] == "CTQ") {
                  if (value && value.toLowerCase() == "yes") {
                    obj[[keyArr[i]]] = true;
                  } else {
                    obj[[keyArr[i]]] = false;
                  }
                } else {
                  obj[[keyArr[i]]] = value;
                }
              })
              sheets[name].push(obj);
            }
          })

        })
        const keysArr = Object.keys(sheets);
        sheets.PartMaster.forEach((one) => {
          one.Standards = sheets.Standards.filter(obj => obj.InspectionType == one.Standards)
          one.Standards.forEach((x) => {
            x.Standard = sheets.Standard.filter(obj => obj.Parameter == x.Standard)
          })
          one.Standards = mergeArrayAggregate(one.Standards, 'InspectionType', 'Standard');
        })

        const result = mergeArrayAggregate(sheets.PartMaster, 'PartID', 'Standards');
        console.log(result, "sheets data")



        // let finalDataArr = []
        // for (let i = 0; i < dataArray.length; i++) {
        //   if (finalDataArr.length == 0) {
        //     let obj1 = { ...dataArray[i] }
        //     delete obj1.PartID;
        //     delete obj1.PartName;
        //     let obj = { PartID: dataArray[i].PartID, PartName: dataArray[i].PartName, Standards: [] };
        //     obj.Standards.push(obj1)
        //     finalDataArr.push(obj);
        //   } else {
        //     let filterData = finalDataArr.filter(one => one.PartID == dataArray[i].PartID)
        //     if (filterData.length > 0) {
        //       let obj = { ...dataArray[i] }
        //       finalDataArr.filter(one => one.PartID == dataArray[i].PartID)[0].Standards.push(obj)
        //     } else {
        //       let obj1 = { ...dataArray[i] }

        //       let obj = { PartID: dataArray[i].PartID, PartName: dataArray[i].PartName, Standards: [] };
        //       obj.Standards.push(obj1)
        //       finalDataArr.push(obj);
        //     }
        //   }
        // }
        // finalDataArr.forEach((one) => {
        //   one.PartID = one.PartID ? one.PartID.toString() : one.PartID;
        //   one.PartName = one.PartName ? one.PartName.toString() : one.PartName;
        //   let opSerial = 1
        //   one.Standards.forEach((op,) => {
        //     delete op.PartID
        //     delete op.PartName
        //     op.StandardSerial = opSerial;
        //     opSerial++;
        //   })
        // })


        self.setState({ excelData: result });
        await self.sendDataToServer(result, result, self.state.arrayProcessIndex)
        console.log("Data>>>" + result);
      };
      // }
      // else {
      //   swal('File Size Should Be Between 2KB to 50KB');
      // }
    }
    document.body.removeChild(link);

  }



  schemaFull = {

    PartID: joi.any().required().label("Part Id"),
    PartName: joi.string().required().label("Part Name"),
    _id: joi.string(),


    Standards: joi
      .array()
      .items(
        joi.object().keys({
          _id: joi.string(),
          InspectionType: joi.string().required(),
          StandardVersion: joi.any(),
          EffectiveFrom: joi.date(),
          UpdatedAt: joi.date(),
          Standard: joi.array().min(1),
        })
      )
      .unique('InspectionType')
      .min(1)
      .required()
      .label("Duplicate Inspection Add"),
  };


  sendDataToServer = async (EquipsArr, originalDataArray, idx) => {
    this.setState({ querySuccess: true })

    for (let index = idx; index < EquipsArr.length; index += 1) {
      try {
        let error = valid.validate(EquipsArr[index], this.schemaFull);
        if (error !== null) {
          let row = index + 1
          this.setState({ errors: error, querySuccess: false, errorModal: true, rowNumber: row });
          break;

        } else {
          let res = await axios.post(api.api + 'partMaster', EquipsArr[index])
          await (async () => {
            const result = await axios.get(
              api.api1 + 'partMaster'
            );
            // setQuerySuccess(false)
            this.setState({ componentList: result.data });
          })();
          if (res.data == 'Insert') {
            toast.success('🦄 Save Part For - ' + EquipsArr[index].PartID, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

        }
      }
      catch (err) {

        if (err.response.data.code == 11000) {
          this.AbortAndResumeProcess(EquipsArr, originalDataArray, index)
        } else {
          let message = JSON.parse(err.response.data.message);
          this.setState({ querySuccess: true, objKey: message.key, errorMessage: message.message, errorFlag: true })
          this.insertIfNotExistDataTypeAndResumeProcess(message.message, message.key.toLowerCase(), message.key, EquipsArr[index][message.key], originalDataArray, index);
        }
        break;
      }

    }
    this.setState({ querySuccess: false })
  }

  AbortAndResumeProcess = (dataArray, originalArr, index) => {
    let row = index + 1;
    swal({
      title: "Are you sure?",
      text: ' This component already exist skip this component!  ' + dataArray[index].ComponentId + "  at row number " + row,
      icon: "warning",
      buttons: ["Abort Process", "Skip Continue"],
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        index = index + 1;
        this.sendDataToServer(dataArray, originalArr, index)
      } else {
        this.setState({ querySuccess: false, arrayProcessIndex: index })
        swal('Process  Abort', { dangerMode: true });

        // swal("Your imaginary file is safe!");
      }
    });
  }



  insertIfNotExistDataTypeAndResumeProcess = (errorMessage, url, key, value, dataArray, index) => {
    swal({
      title: "Are you sure?",
      text: `${errorMessage}` + '  , Do you want to skip this component ?  ',
      icon: "error",
      buttons: ["Abort Process", "Skip Continue"],
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.setState({ errorFlag: false });
        index = index + 1;
        this.sendDataToServer(dataArray, dataArray, index)
      } else {
        this.setState({ querySuccess: false, arrayProcessIndex: index })
        swal('Process  Abort')

        // swal("Your imaginary file is safe!");
      }
    });
  }



  handleDownloadFormat = () => {
    axios.get(api.api + 'ComponentMasterTemplate')
      .then((result) => {
        if (result.status == 200) {
          // const url = window.URL.createObjectURL(new Blob([result.data]));
          let link = document.createElement('a');
          link.setAttribute('href', result.data);
          link.setAttribute('download', 'ComponentMasterFormat.xlsx');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        else {
          swal('Error In Downloading File')
        }
      })
      .catch((err) => {
        toast.success(`${err}`, {
          position: 'bottom-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            background: 'red', // Set your desired background color
            color: 'white',     // Set your desired text color
          },
        });
      })
  }

  handleHideModal = () => {
    this.setState({ errorModal: false })
  }



  render() {


    return (
      <React.Fragment>
        {this.state.querySuccess ? <Loading /> : ''}
        <ToastContainer />
        <Modal
          show={this.state.errorModal}
          onHide={this.handleHideModal}
          backdrop="static"
          keyboard={false}
          size='sm'
        >
          <Modal.Header closeButton>
            <Modal.Title>Equipment Validate Error List</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {Object.keys(this.state.errors).map(key => {
              return <p className='text-danger ' style={{ fontSize: 11 }}>{this.state.errors[key] + "  " + "Row Number  " + this.state.rowNumber}</p>
            })}
          </Modal.Body>
          {/* <Modal.Footer>
                <Button className='bg-primary' variant="secondary" >
                    Save
        </Button>
                <Button variant="secondary" onClick={handleHideModal}>
                    Close
        </Button>

            </Modal.Footer> */}
        </Modal>
        <div className='text-center'>
          <p>Part Master</p>
        </div>
        <a onClick={() => this.props.history.push('/setting/partMaster/add', { action: "add", data: {} })} style={{ cursor: 'pointer' }} className='float-right common-anchor'

        >
          <FontAwesomeIcon size='1x' icon={faPlus} /> Add</a>

        <a
          style={{ cursor: "pointer", color: 'white' }}
          className="float-left btn btn-sm btn-primary "
          onClick={this.handleUploadGuagesDoc}
        >
          {" "}

          <FontAwesomeIcon size="1x" icon={faFileImport} /> Import Excel
        </a>

        {/* <a
          style={{ cursor: "pointer", color: 'white' }}
          className="float-left btn btn-sm btn-primary "
          onClick={this.handleDownloadFormat}
        >


          <FontAwesomeIcon size="1x" icon={faDownload} /> Download Template
        </a> */}
        {this.state.componentList.length < 0 ? "Data Not Available" : <Table columns={this.columns} onSort={this.handleSort} sortColumn={this.state.sortColumn} data={this.state.componentList} />}
      </React.Fragment>

    );
  }
}

export default PartMasterTable;
